import { render, staticRenderFns } from "./sexualOffences.vue?vue&type=template&id=2f2fd3aa&scoped=true"
import script from "./sexualOffences.vue?vue&type=script&lang=js"
export * from "./sexualOffences.vue?vue&type=script&lang=js"
import style0 from "./sexualOffences.vue?vue&type=style&index=0&id=2f2fd3aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2fd3aa",
  null
  
)

export default component.exports